<template>
    <KCard
        :as="as"
        :variant="variant"
        :class="block()"
        :aria-labelledby="title ? titleId : undefined"
        :aria-label="title ? undefined : label"
    >
        <KEyebrow
            v-if="title"
            :id="titleId"
            as="h3"
            :class="element('title')"
        >
            {{ title }}
        </KEyebrow>

        <ul :class="element('list')">
            <li
                v-for="(item, index) in items"
                :key="`${item.label}:${item.href}`"
                :class="element('item')"
            >
                <component
                    :is="linkAs"
                    :class="element('link')"
                    v-bind="linkAttributes(item)"
                    @click="emit('select', { item, index })"
                >
                    <span>{{ item.label }}</span>
                    <svg
                        :class="element('arrow')"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.75"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                    >
                        <path d="M5 12h14" />
                        <path d="m13 6 6 6-6 6" />
                    </svg>
                </component>
            </li>
        </ul>
    </KCard>
</template>

<script setup lang="ts">
import type { KLinkBlockItem, KLinkBlockProps, KLinkBlockSelectEvent } from './types'
import useBem from '@yeeroen/use-bem'

import { useId } from 'vue'

import KCard from '../card/k-card.vue'
import KEyebrow from '../eyebrow/k-eyebrow.vue'

defineOptions({ name: 'KLinkBlock' })

withDefaults(defineProps<KLinkBlockProps>(), {
    as: 'nav',
    label: 'Related links',
    items: () => [],
    linkAs: 'a',
    variant: 'subtle',
})

const emit = defineEmits<{
    select: [event: KLinkBlockSelectEvent]
}>()

const { block, element } = useBem('k-link-block')
const titleId = `k-link-block-${useId()}`

function linkAttributes(item: KLinkBlockItem) {
    return {
        href: item.href,
        target: item.external ? '_blank' : undefined,
        rel: item.external ? 'noopener noreferrer' : undefined,
    }
}
</script>

<style lang="scss">
@use './k-link-block.scss';
</style>
